// cr media描述

import RowStars from "../common/RowStars";
import { MEDIA_CONTENT } from "../common/constant";

const CRMediaDescription = () => {
    return(
        <>
            {/* 手機版才顯示英文 */}
            <p className={`text-black4 text-bd2n text-center asm:hidden`}>{MEDIA_CONTENT?.[2]}</p>

            <div className="flex flex-col w-full h-full usm:flex-col-reverse center-center gap-[16px] usm:gap-[28px]">
                <div className="text-center">
                    <p className="text-black9 text-bd1n" >{MEDIA_CONTENT?.[3]}</p>
                    <p className="text-black9 text-bd1n" >{MEDIA_CONTENT?.[4]}</p>
                </div>

                {/* 虛線+星+虛線 */}
                <div className="w-[30%] usm:w-full relative flex items-center justify-center">
                    {/* 虛線 */}
                    <div className="w-full border-b-1 border-dashed border-b-red0 translate-y-[-50%]">
                        &nbsp;
                    </div>
                    <div className="relative px-[10px] usm:px-[28px] flex-shrink-0">
                        <RowStars repeat={4}/>
                    </div>
                    {/* 虛線 */}
                    <div className="w-full border-b-1 border-dashed border-b-red0 translate-y-[-50%]">
                        &nbsp;
                    </div>
                </div>
            </div>
        </>
    )
}

export default CRMediaDescription;